import http from '@/http'
import createCrudModule from 'vuex-crud'

export default createCrudModule({
  client: http,
  resource: '/gallery',
  urlRoot: '/gallery'
})
